import React from 'react';
import { Calendar, MapPin, Clock, ExternalLink, Ticket } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';

const Shows = ({ shows }) => {
  const getPlatformColor = (platform) => {
    const colors = {
      'Eventbrite': 'bg-orange-500',
      'Dice': 'bg-purple-500',
      'Backyard': 'bg-burgundy',
      "King's Head": 'bg-burgundy'
    };
    return colors[platform] || 'bg-gray-500';
  };

  return (
    <section id="shows" className="py-20 bg-gradient-to-br from-pink/40 via-pink/20 to-white relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-burgundy/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-pink/20 rounded-full blur-3xl"></div>

      <div className="max-w-6xl mx-auto px-6 relative z-10">
        <div className="text-center mb-12">
          <div className="inline-block mb-4">
            <Ticket className="w-12 h-12 text-burgundy mx-auto" strokeWidth={1.5} />
          </div>
          <h2 className="text-4xl md:text-5xl font-playfair font-bold text-burgundy mb-4">
            Upcoming Shows
          </h2>
          <p className="text-xl text-gray-700">
            Catch me live at these London comedy venues
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {shows.map((show) => (
            <Card key={show.id} className="overflow-hidden hover:shadow-2xl transition-all duration-300 border-2 border-burgundy/20 bg-white hover:-translate-y-2 flex flex-col">
              <CardHeader className="bg-gradient-to-br from-pink/20 via-burgundy/5 to-transparent pb-4">
                <div className="flex items-start justify-between mb-2">
                  <Badge className={`${getPlatformColor(show.platform)} text-white rounded-full shadow-md`}>
                    {show.platform}
                  </Badge>
                  <Badge variant="outline" className="border-2 border-burgundy text-burgundy rounded-full font-semibold">
                    {show.role}
                  </Badge>
                </div>
                <CardTitle className="text-2xl font-playfair text-burgundy">
                  {show.title}
                </CardTitle>
                <CardDescription className="text-base font-medium text-gray-700">
                  {show.venue}
                </CardDescription>
              </CardHeader>
              <CardContent className="pt-6 flex-1 flex flex-col">
                <div className="space-y-3 mb-4">
                  <div className="flex items-center gap-3 text-gray-700 bg-pink/10 p-3 rounded-lg">
                    <Calendar className="w-5 h-5 text-burgundy" />
                    <span className="font-medium">{show.displayDate}</span>
                  </div>
                  <div className="flex items-center gap-3 text-gray-700 bg-burgundy/10 p-3 rounded-lg">
                    <Clock className="w-5 h-5 text-burgundy" />
                    <span>{show.time}</span>
                  </div>
                  <div className="flex items-center gap-3 text-gray-700 bg-pink/10 p-3 rounded-lg">
                    <MapPin className="w-5 h-5 text-burgundy" />
                    <span>{show.location}</span>
                  </div>
                </div>

                <p className="text-gray-600 mb-4 leading-relaxed flex-1">
                  {show.description}
                </p>

                <a
                  href={show.ticketUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block mt-auto"
                >
                  <Button className="w-full bg-gradient-to-r from-burgundy to-bordeaux hover:from-bordeaux hover:to-burgundy text-white rounded-full font-semibold transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl py-6 text-base">
                    Get Tickets
                    <ExternalLink className="w-4 h-4 ml-2" />
                  </Button>
                </a>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Shows;
